// extracted by mini-css-extract-plugin
module.exports = {"activityText":"widget-demo--activityText--24N4T","md":"widget-demo--md--2PLNq"};